// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Roboto:wght@100;500;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
https://coolors.co/d6cfc5-9d8d7e-0a1b61-70815b-51723b-e8871e-e16e39-bd1719-83280b-441d16
 */

/** {outline: 1px solid red;}*/

:root {
  --background: #E9D8A6;
  --header-background: #E9D8A6;
  --logoShade1: #EE9B00;
  --logoShade2: #CA6702;
  --logoShade3: #BB3E03;
  --link-hover: #BD1719;

  --false-statement-background-border: #AE2012;
  --false-statement-background: #AE2012;
  --true-statement-background-border: #005F73;
  --true-statement-background: #005F73;
  --button-background-border: #0A9396;
  --button-background: #0A9396;

  --roulette-red: #AE2012;
  --roulette-black: #001219;
  --roulette-table: #005F73;
  --roulette-highlight: #EE9B00;

  --font-light: #E9D8A6;
  --font-dark: #001219;
}

.App {
  font-family: Roboto, Arial;
  text-align: center;
  background: var(--background);
  color: #001219;
  width: 100vw;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  font-weight: 500;
}

@media screen and (max-width: 799px) {
  .content {
    max-width: 100vw;
  }
}

@media screen and (min-width: 800px) {
  .content {
    max-width: 800px;
  }
}

.content {
  margin: 3rem;
  margin-bottom: 6rem;
  display:flex;
  flex-direction: column;
}

.content-container {
  margin-top: 3rem;
  display:flex;
  flex-direction: column;
}

a {
  font-weight: 900;
  color:var(--font-dark);
  text-decoration: none;
}

a:hover {
  color: var(--logoShade3);
}

button {
  cursor: pointer;
}

button:hover {
  color: var(--logoShade1);
}

.font-light {
  color: var(--font-light);
}

button {
  font-size: 1.2rem;
  font-weight: 900;
  color: var(--font-light);
  background: var(--button-background);
  height: min-content;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.text-align-left {
  text-align: left;
}

.text-align-center {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE;;AAGF,8BAA8B;;AAE9B;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,4CAA4C;EAC5C,qCAAqC;EACrC,2CAA2C;EAC3C,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;;EAE5B,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;;EAE7B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/*\nhttps://coolors.co/d6cfc5-9d8d7e-0a1b61-70815b-51723b-e8871e-e16e39-bd1719-83280b-441d16\n */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Roboto:wght@100;500;900&display=swap');\n\n/** {outline: 1px solid red;}*/\n\n:root {\n  --background: #E9D8A6;\n  --header-background: #E9D8A6;\n  --logoShade1: #EE9B00;\n  --logoShade2: #CA6702;\n  --logoShade3: #BB3E03;\n  --link-hover: #BD1719;\n\n  --false-statement-background-border: #AE2012;\n  --false-statement-background: #AE2012;\n  --true-statement-background-border: #005F73;\n  --true-statement-background: #005F73;\n  --button-background-border: #0A9396;\n  --button-background: #0A9396;\n\n  --roulette-red: #AE2012;\n  --roulette-black: #001219;\n  --roulette-table: #005F73;\n  --roulette-highlight: #EE9B00;\n\n  --font-light: #E9D8A6;\n  --font-dark: #001219;\n}\n\n.App {\n  font-family: Roboto, Arial;\n  text-align: center;\n  background: var(--background);\n  color: #001219;\n  width: 100vw;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n  font-weight: 500;\n}\n\n@media screen and (max-width: 799px) {\n  .content {\n    max-width: 100vw;\n  }\n}\n\n@media screen and (min-width: 800px) {\n  .content {\n    max-width: 800px;\n  }\n}\n\n.content {\n  margin: 3rem;\n  margin-bottom: 6rem;\n  display:flex;\n  flex-direction: column;\n}\n\n.content-container {\n  margin-top: 3rem;\n  display:flex;\n  flex-direction: column;\n}\n\na {\n  font-weight: 900;\n  color:var(--font-dark);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--logoShade3);\n}\n\nbutton {\n  cursor: pointer;\n}\n\nbutton:hover {\n  color: var(--logoShade1);\n}\n\n.font-light {\n  color: var(--font-light);\n}\n\nbutton {\n  font-size: 1.2rem;\n  font-weight: 900;\n  color: var(--font-light);\n  background: var(--button-background);\n  height: min-content;\n}\n\n.flex {\n  display: flex;\n}\n\n.column {\n  flex-direction: column;\n}\n\n.text-align-left {\n  text-align: left;\n}\n\n.text-align-center {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
